import React from "react";
import { Input, SaveProgress } from "components";

import styled from "react-emotion";
import * as styles from "./editPictureCatalog.styles";
import EditImageItems from "./EditImageItems";
import { Button } from "appStyles";
import { borderContainer } from "../editTemplate.styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { withRedux } from "helpers";

import { imageView } from "defaultStates";

const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

const PictureCatalog = (props) => {
  const updateSectionHeader = (idx) => (value) => {
    const updatedComponent = { ...props.component };
    updatedComponent.view.sections[idx].header.text = value;
    props.updateComponent(updatedComponent);
  };

  const updateApplication = () => {
    let { activeApp, business, callback, activeTemplate } = props;
    // console.log(activeTemplate);

    activeTemplate.components[0].view.sections.forEach((section) => {
      var filteredNullImages = section.images.filter((image) => {
        return image.url !== null;
      });
      section.images = filteredNullImages;
    });

    props.actions.putBusinessApp(business, activeApp);
    props.actions.updateActiveEditor(null);
  };

  const updateImage = (sectionIdx) => (imageIdx, field, value) => {
    const updatedComponent = { ...props.component };
    updatedComponent.view.sections[sectionIdx].images[imageIdx][field] = value;
    updatedComponent.view.sections[sectionIdx].images[imageIdx].isTemp = false;
    props.updateComponent(updatedComponent);
  };

  const updateImages = (sectionIdx) => (images) => {
    const updatedComponent = { ...props.component };
    updatedComponent.view.sections[sectionIdx].images = images;
    props.updateComponent(updatedComponent);
  };

  const removeImage = (sectionIdx) => (imageIdx) => {
    const updatedComponent = { ...props.component };
    updatedComponent.view.sections[sectionIdx].images.splice(imageIdx, 1);
    props.updateComponent(updatedComponent);
  };

  const addNewImage = (sectionIdx) => () => {
    const updatedComponent = { ...props.component };
    updatedComponent.view.sections[sectionIdx].images.push(imageView());
    props.updateComponent(updatedComponent);
  };

  const removeSection = (sectionIdx) => () => {
    const { component } = props;
    // console.log("removing section..." + sectionIdx);
    // console.dir(component);

    const updatedComponent = JSON.parse(JSON.stringify(component));
    // console.dir(updatedComponent);
    updatedComponent.view.sections.splice(sectionIdx, 1);
    // console.log("updated component after deleting section");
    // console.dir(updatedComponent);
    props.updateComponent(updatedComponent);
    updateApplication();
  };

  const { appId, component, section, activeEditor, croppingAspectRatio } =
    props;
  // console.log("modal child recieved component: ");
  // console.dir(component);
  const columns = component.view.columns;
  const { sections } = component.view;

  return (
    <div className={borderContainer}>
      <H2 style={{ marginBottom: "20px" }}>Edit Section</H2>
      {sections.map((s, idx) => {
        if (activeEditor === idx) {
          return (
            <div className={styles.section} key={idx}>
              <Input
                field="Section Title"
                defaultValue={s.header.text}
                onChange={updateSectionHeader(idx)}
              />
              <div
                style={{
                  marginTop: "20px",
                }}
              >
                <EditImageItems
                  appId={appId}
                  columns={columns}
                  images={s.images}
                  // this is where croppingAspectRatio is being sent as undefined
                  croppingAspectRatio={null}
                  removeImage={removeImage(idx)}
                  addNewImage={addNewImage(idx)}
                  updateImages={updateImages(idx)}
                  onChange={updateImage(idx)}
                  {...props}
                />
              </div>

              <div
                style={{
                  margin: "0.3em",
                }}
              >
                <Button
                  background="#89D2D3"
                  onClick={addNewImage(idx)}
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    fontStyle: "normal",
                    fontStretch: "normal",
                    letterSpacing: "normal",
                    margin: "0px",
                    display: "inline-flex",
                    alignItems: "center",
                    textAlign: "center",
                    lineHeight: "29px",
                    borderRadius: "5.5px",
                    backgroundColor: "#89d2d3",
                    boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                    textTransform: "none",
                  }}
                >
                  <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
                  Add New Image
                </Button>
              </div>
              <div
                style={{
                  margin: "0.3em",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <a
                  onClick={removeSection(idx)}
                  style={{
                    fontSize: "11px",
                    backgroundColor: "none",
                    width: "50%",
                    textDecoration: "underline",
                    cursor: "pointer",
                    paddingTop: "40px",
                  }}
                >
                  Delete Section
                </a>
                <SaveProgress />
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default withRedux(PictureCatalog);
